import React, { Component } from 'react';
import { Card, CardHeader, CardBody, FormGroup, Label, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import moment from 'moment';
import async from 'async';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, numberFilter, dateFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
const { ExportCSVButton } = CSVExport;

import TicketEditor from './Editor';

import Lang from '../../languages';
import Config from '../../config';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

class TicketsList extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   passwd: '',
   ticket: null,
   totalSize: 0,
   sizePerPage: 10,
   editorWindow: false,
   selected: [],
   packets: true
  };

  this.filters = { 'text': {}, 'number': {}, 'date': {} }

  if (window.innerWidth <= 768) {
   this.columns = [
    { dataField: 'name', text: Lang[this.props.session.language].Tickets.columns.ticketName, sort: true }
   ]
  } else {
   this.columns = [
    { dataField: 'name', text: Lang[this.props.session.language].Tickets.columns.ticketName, filter: textFilter({ getFilter: (filter) => { this.filters['text'].ticketName = filter } }), sort: true },
    { dataField: 'ownerName', text: Lang[this.props.session.language].Tickets.columns.ownerName, filter: textFilter({ getFilter: (filter) => { this.filters['text'].ownerName = filter } }), sort: true },
    { dataField: 'productName', text: Lang[this.props.session.language].Tickets.columns.productName, filter: textFilter({ getFilter: (filter) => { this.filters['text'].productName = filter } }), sort: true },
    { dataField: 'establishmentName', text: Lang[this.props.session.language].Tickets.columns.establishmentName, filter: textFilter({ getFilter: (filter) => { this.filters['text'].establishmentName = filter } }), sort: true },
    { dataField: 'clientName', text: Lang[this.props.session.language].Tickets.columns.clientName, filter: textFilter({ getFilter: (filter) => { this.filters['text'].clientName = filter } }), sort: true },
    { dataField: 'startDate', text: Lang[this.props.session.language].Tickets.columns.startDate, filter: dateFilter({ getFilter: (filter) => { this.filters['date'].startDate = filter } }), formatter: (cellContent, row) => { return moment(cellContent).format(Lang[this.props.session.language].datetimeFormat); }, sort: true },
    { dataField: 'finishDate', text: Lang[this.props.session.language].Tickets.columns.finishDate, filter: dateFilter({ getFilter: (filter) => { this.filters['date'].finishDate = filter } }), formatter: (cellContent, row) => { return moment(cellContent).format(Lang[this.props.session.language].datetimeFormat); }, sort: true },
    /*{ dataField: 'cancellationUntil', text: Lang[this.props.session.language].Tickets.columns.cancellationUntil, filter: dateFilter({ getFilter: (filter) => { this.filters['date'].cancellationUntil = filter } }), formatter: (cellContent, row) => { return moment(cellContent).format(Lang[this.props.session.language].datetimeFormat); }, sort: true },
    { dataField: 'usesLeft', text: Lang[this.props.session.language].Tickets.columns.usesLeft, filter: numberFilter({ getFilter: (filter) => { this.filters['number'].usesLeft = filter } }), sort: true },*/
    {
     dataField: 'ID', text: 'ID', headerStyle: () => { return { width: '60px' } }, headerFormatter: () => (
      <Button className="float-right" title="Restablecer filtros" onClick={this.resetFilters}><i className="fa fa-filter"></i></Button>
     ),
     formatter: (cellContent, row) => {
      return (
       <div className="checkbox disabled">
        {
         this.props.session.permissions.controllers.tickets.find(el => el == 'delete') ?
          <Button color="danger" onClick={() => this.doDelete(row.ID)}><i className="fa fa-trash"></i></Button>
          : (this.props.session.user.ID == row.owner || this.props.session.user.ID == row.parent)  ?
           <Button color="danger" onClick={() => this.doDelete(row.ID)}><i className="fa fa-trash"></i></Button>
           : null
        }
       </div>
      )
     }
    }
   ]
  }


  this.doDelete = this.doDelete.bind(this);

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);

  this.resetFilters = this.resetFilters.bind(this);

  this.handleOnSelect = this.handleOnSelect.bind(this);
  this.handleOnSelectAll = this.handleOnSelectAll.bind(this);
  this.handleTableChange = this.handleTableChange.bind(this);
  this.handleClickDelete = this.handleClickDelete.bind(this);

  this.forceTableChange = this.forceTableChange.bind(this);

  this.lastRequest = {}
 }

 resetFilters() {
  Object.keys(this.filters).forEach(type => {
   Object.keys(this.filters[type]).forEach(key => {
    var filterFunction = this.filters[type][key];
    switch (type) {
     case 'text': filterFunction(''); break;
     case 'date': filterFunction({ date: new Date(), comparator: '' }); break;
     case 'number': filterFunction({ number: '', comparator: '' }); break;
    }
   });
  })
 }

 handleOnSelect(row, isSelect, rowIndex, e) {
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, row.ID] });
  } else {
   this.setState({ selected: this.state.selected.filter(x => x !== row.ID) });
  }
 }

 handleOnSelectAll(isSelect, rows, e) {
  const IDs = rows.map(r => r.ID);
  if (isSelect) {
   this.setState({ selected: [...this.state.selected, ...IDs] });
  } else {
   this.setState({ selected: this.state.selected.filter((e) => { return IDs.indexOf(e) < 0 }) });
  }
 }

 handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }) {
  if (type !== 'cellEdit') {
   this.lastRequest = { page, sizePerPage, sortField, sortOrder, filters, language: this.props.session.language, packets: this.state.packets };
   this.props.reqAPI(Config.apiURI + '/api/tickets', 'POST', this.lastRequest).then(data => {
    this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, filters, sortField, sortOrder }));
   }).catch((error) => {
    console.error(error);
   });
  } else {
   this.props.reqAPI(Config.apiURI + '/api/tickets', 'PUT', cellEdit).then((result) => {
    var newItems = this.state.data;
    for (var i = 0; i < newItems.length; i += 1) {
     if (newItems[i].ID === result.ID) newItems[i] = result;
    }

    this.setState({ data: newItems });
   }).catch((error) => {
    console.error(error);
   })
  }
 }

 forceTableChange() {
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 handleClickDelete(IDs, onClose) {
  if (this.state.confirmValue == Lang[this.props.session.language].DeleteConfirmValue) {
   var jobs = [];
   var self = this;
   var url = this.state.packets ? '/api/tickets/packets/' : '/api/tickets/';
   IDs.map((ID) => {
    jobs.push(function (callback) {
     self.props.reqAPI(Config.apiURI + url + ID, 'DELETE').then(result => {
      callback(false, result);
     });
    })
   })

   async.parallel(jobs, function (err, results) {
    onClose();
    self.setState({ confirmValue: '' }, () => {
     self.handleTableChange('reload', {
      page: self.state.page,
      sizePerPage: self.state.sizePerPage,
      filters: self.state.filters,
      sortField: self.state.sortField,
      sortOrder: self.state.sortOrder
     });
    })

    for (var key = 0; key < results.length; key++) {
     if (results[key].success) toast.success(Lang[self.props.session.language].Tickets.hasBeenDeleted());
     else toast.error(Lang[self.props.session.language].Tickets.hasNotBeenDeleted(), { autoClose: 10000 });
    }
   });
  }
 }


 doDelete(ID, error = false) {
  var IDs = ID === null ? this.state.selected : typeof (ID) === 'object' ? ID : [ID];
  confirmAlert({
   customUI: ({ onClose }) => {
    return (
     <Card className='confirm-delete alert-danger'>
      <CardBody>
       <h2>{Lang[this.props.session.language].DeleteConfirmTitle}</h2>
       <p>{Lang[this.props.session.language].Tickets.isGoingToDelete(IDs)}</p>
       <p><strong>{Lang[this.props.session.language].DeleteConfirmMessage}</strong></p>
       <InputGroup>
        <Input type="text" placeholder={Lang[this.props.session.language].DeleteConfirmPlaceholder}
         onKeyPress={(event) => { if (event.key === 'Enter') this.handleClickDelete(IDs, onClose); }}
         onChange={(e) => { this.setState({ confirmValue: e.target.value }); }}
         className={error ? 'border border-danger' : ''}
        />
        <InputGroupAddon addonType="append">
         <Button color="danger" onClick={() => { this.handleClickDelete(IDs, onClose); }}>{Lang[this.props.session.language].DeleteConfirmYES}</Button>
         <Button color="primary" onClick={onClose}>{Lang[this.props.session.language].DeleteConfirmNO}</Button>
        </InputGroupAddon>
       </InputGroup>
      </CardBody>
     </Card>
    );
   }
  });
 }


 openEditor(ID) {
  if (ID === null) {
   this.setState({ ticket: null }, function () {
    this.setState({ editorWindow: true });
   });
  } else {
   this.props.reqAPI(Config.apiURI + '/api/tickets/' + ID + '?full').then(ticket => {
    this.setState({ ticket: ticket }, function () {
     this.setState({ editorWindow: true });
    });
   })
  }
 }

 closeEditor(state) {
  if (state) toast.success('Los cambios han sido guardados');
  this.setState({ ticket: null, editorWindow: false });
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }


 componentDidMount() {
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }


 render() {
  return (
   <Card>
    <ToolkitProvider keyField="ID" data={this.state.data} columns={this.columns} exportCSV>
     {
      props => (
       <CardBody>
        <ExportCSVButton className="btn btn-primary" {...props.csvProps}>{Lang[this.props.session.language].ExportCSV}</ExportCSVButton>
        {' '}
        {
         this.state.selected.length > 0 ?
          <Button color="danger" onClick={() => this.doDelete(null)}><i className="fa fa-minus"></i> {Lang[this.props.session.language].Tickets.buttons.delSelected}</Button>
          : null
        }
        <FormGroup className="float-right" check inline>
         <Input type="checkbox" onChange={(e) => { this.setState({packets: !e.target.checked}, this.forceTableChange) } } />
         <Label check>{Lang[this.props.session.language].Tickets.buttons.showAsTickets}</Label>
        </FormGroup>

        <BootstrapTable
         remote
         striped
         condensed
         bootstrap4
         keyField="ID"
         bordered={false}
         data={this.state.data}
         columns={this.columns}
         selectRow={{
          mode: 'checkbox',
          onSelect: this.handleOnSelect,
          onSelectAll: this.handleOnSelectAll
         }}
         defaultSorted={[{
          dataField: 'name',
          order: 'asc'
         }]}
         filter={filterFactory()}
         pagination={
          paginationFactory({
           page: this.state.page,
           sizePerPage: this.state.sizePerPage,
           sizePerPageList: [
            { text: '5', value: 5 },
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '50', value: 50 },
            { text: '100', value: 100 }
           ],
           showTotal: true,
           totalSize: this.state.totalSize,
           firstPageText: Lang[this.props.session.language].pagination.firstPageText,
           prePageText: Lang[this.props.session.language].pagination.prePageText,
           nextPageText: Lang[this.props.session.language].pagination.nextPageText,
           lastPageText: Lang[this.props.session.language].pagination.lastPageText,
           firstPageTitle: Lang[this.props.session.language].pagination.firstPageTitle,
           nextPageTitle: Lang[this.props.session.language].pagination.nextPageTitle,
           prePageTitle: Lang[this.props.session.language].pagination.prePageTitle,
           lastPageTitle: Lang[this.props.session.language].pagination.lastPageTitle,
           paginationTotalRenderer: (from, to, size) => (
            <span className="react-bootstrap-table-pagination-total" dangerouslySetInnerHTML={{ __html: '&nbsp;' + Lang[this.props.session.language].paginationFooter(from, to, size) + ' ' + Lang[this.props.session.language].Tickets.name }} />
           )
          })
         }
         onTableChange={this.handleTableChange}
         noDataIndication={Lang[this.props.session.language].tableEmpty}
         {...props.baseProps} />
       </CardBody>
      )
     }
    </ToolkitProvider>

    <TicketEditor {...this.props} open={this.state.editorWindow} ticket={this.state.ticket} handleClose={this.closeEditor} onComplete={this.closeEditor} />
   </Card>
  )
 }
}

export default TicketsList;



// WEBPACK FOOTER //
// ./websources/views/Tickets/List.js